import { IBRMInputState } from '../../interfaces/states/IBRMInputState';
import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IBRMInput } from '../../api/brm/brm-utils';

const initialState: IBRMInputState = { brmInputs: [] };

class BRMInputReducer extends ImmerReducer<IBRMInputState> {
  public setBRMInputState(brmInputs: IBRMInput[]): void {
    this.draftState.brmInputs = brmInputs;
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const BRMInputActions = createActionCreators(BRMInputReducer);
export const BRMInputReducerFunction = createReducerFunction(BRMInputReducer, initialState);
